import { API } from '../api/API';
import useAuthStore from '../store/authStore';

const receptionService = {
  getAllReceptions: async (params = {}) => {
    try {
      const store = useAuthStore.getState();
      const user = store.user;

      const {
        page = 1,
        limit = 10,
        date_in_start,
        date_in_end,
        date_out_start,
        date_out_end,
        assure_id,
        agent_clinique_id,
        statut,
        ...otherFilters
      } = params;

      const queryParams = {
        page,
        limit,
        partenaire_id: user?.partie_id,
        // Ajoute le filtre agent_clinique_id si l'utilisateur est un agent clinique
        ...(user?.role === 'agent_clinique' && { agent_clinique_id: user.id }),
        ...(date_in_start && { date_in_start }),
        ...(date_in_end && { date_in_end }),
        ...(date_out_start && { date_out_start }),
        ...(date_out_end && { date_out_end }),
        ...(assure_id && { assure_id }),
        ...(typeof statut !== 'undefined' && { statut }),
        ...otherFilters
      };
      
      const response = await API.get('/receptions', { params: queryParams });
      return {
        success: true,
        data: response.data.data,
        pagination: response.data.pagination,
        filters: response.data.filters,
        message: 'Réceptions récupérées avec succès'
      };
    } catch (error) {
      console.error('Erreur lors de la récupération des réceptions:', {
        message: error.message,
        response: error.response?.data
      });
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors de la récupération des réceptions',
        error: error.response?.data
      };
    }
  },

  createReception: async (receptionData) => {
    try {
      const store = useAuthStore.getState();
      const user = store.user;
      
      const data = {
        assure_id: receptionData.assure_id,
        agent_clinique_id: user.id,
        partenaire_id: user.partie_id, // Utiliser structure_id au lieu de partie_id
        partenaire_type: "clinique",
        date_in: new Date().toISOString(),
        statut: false,
        commentaire: receptionData.commentaire
      };
      
      const response = await API.post('/receptions', data);
      return {
        success: true,
        data: response.data,
        message: 'Réception créée avec succès'
      };
    } catch (error) {
      console.error('Erreur lors de la création de la réception:', {
        message: error.message,
        response: error.response?.data
      });
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors de la création de la réception',
        error: error.response?.data
      };
    }
  },

  getReceptionById: async (id) => {
    try {
      const response = await API.get(`/receptions/${id}`);
      return {
        success: true,
        data: response.data,
        message: 'Réception récupérée avec succès'
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors de la récupération de la réception',
        error: error.response?.data
      };
    }
  },

  updateReception: async (id, updateData) => {
    try {
      const response = await API.put(`/receptions/${id}`, updateData);
      return {
        success: true,
        data: response.data,
        message: 'Réception mise à jour avec succès'
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors de la mise à jour de la réception',
        error: error.response?.data
      };
    }
  },

  deleteReception: async (id) => {
    try {
      const response = await API.delete(`/receptions/${id}`);
      return {
        success: true,
        data: response.data,
        message: 'Réception supprimée avec succès'
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors de la suppression de la réception',
        error: error.response?.data
      };
    }
  }
};

export default receptionService;